<template>
  <b-row>
    <b-col class="">
      <h6 class="common_heading">{{ headertext }}</h6>
      <p class="master-content">{{ contenttext }}</p>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    headertext: {
      default: "",
      type: String,
    },
    contenttext: {
      type: String,
      default: "",
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss">
@import "../../assets/variables.scss";

.master-content {
  font-size: 14px;
  color: #999999;
  line-height: 25px;
  margin-top: 4px;
  //margin-bottom: 15px !important;
}

.common_heading {
  font-size: 20px;
  color: $FontColor4;
  font-weight: 600;
  padding-top: 7px;
  // white-space: nowrap
}
</style>
